















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ProjectUpdateDialog from '@/modules/projects/components/projectUpdateDialog.vue';
import quotationGenerationDialog from '@/components/projects/quotationGenerationDialog.vue';
import quotationsRepository from '@/services/quotationsRepository';
import ProjectContactsCard from '@/modules/projects/components/contacts/projectContactsCard.vue';
import QuotationsTable from '@/modules/quotations/components/QuotationsTable.vue';
import InvoicesTable from '@/modules/invoicing/components/InvoicesTable.vue';
import progressStatementGenerationDialog from '@/components/projects/progressStatements/progressStatementGenerationDialog.vue';
import ProgressStatementsTable from '@/modules/progressStatements/components/ProgressStatementsTable.vue';
import MeasurementsTable from '@/modules/measurements/components/MeasurementsTable.vue';
import MeasuringStatesTable from '@/modules/measuringstates/components/measuringStatesTable.vue';
import projectDetails from '@/components/projects/projectDetails.vue';
import ReportsTable from '@/modules/projects/reports/components/ReportsTable.vue';
import projectsRepository from '@/services/projectsRepository';
import notificationService from '@/services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import Project from '@/classes/Project';
import ContractsTable from '@/modules/projects/contracts/components/ContractsTable.vue';
import { DxTabs } from 'devextreme-vue';
import cCard from '@/components/default/Card.vue';

import ActionPointsOverview from '@/modules/actionPoints/components/actionpointsTable.vue';
import tasksTable from '@/modules/shared/tasks/components/tasksTable.vue';

import FileManager from '@/modules/documents/FileManager.vue';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';

import creditNotesTable from '@/modules/creditnotes/components/creditNotesTable.vue';
import OrdersTable from '@/modules/orders/components/OrdersTable.vue';
import ExternalInvoicesTable from '@/modules/externalInvoices/components/ExternalInvoicesTable.vue';

import ProjectStats from '@/modules/projects/components/ProjectStats.vue';
import ProjectPurchaseOverview from '@/modules/projects/components/ProjectPurchaseOverview.vue';
import ProjectInfo from '@/modules/projects/components/ProjectInfo.vue';
import ProjectCommunicationTable from '@/modules/projects/components/communication/ProjectCommunicationTable.vue';
import ProjectCostsTable from '@/modules/projects/components/ProjectCostsTable.vue';
import ProjectCopyPopup from '@/modules/projects/components/ProjectCopyPopup.vue';
import ProjectFiches from '@/modules/projects/components/ProjectFiches.vue';
import ProjectMeasuringStateAgendaOverview from '@/modules/projects/components/ProjectMeasuringStateAgendaOverview.vue';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';

import { DxList } from 'devextreme-vue/list';

import MachineryRentalsTable from '@/modules/machinery/components/MachineryRentalsTable.vue';
import { AssignedContact, IProgressStatementListItemDto, ProjectProgressionDto, PlanningsClient, EmployeesClient, Employee, ISecurityConfig } from '@/data/web-api-client';
import ProjectProgressionDialog from '@/modules/projectMeasuringStateOverview/components/ProjectProgressionDialog.vue';

import { Role } from '@/helpers/constants';
import InvoicePaymentTable from '@/modules/invoicing/components/InvoicePaymentTable.vue';
import { SecurityConfig } from '@/installationConfig';
import AuthenticationService from '@/auth/AuthenticationService';

@Component({
  components: {
    ProjectUpdateDialog,
    quotationGenerationDialog,
    QuotationsTable,
    InvoicesTable,
    progressStatementGenerationDialog,
    ProgressStatementsTable,
    MeasurementsTable,
    MeasuringStatesTable,
    projectDetails,
    cPopup,
    ProjectContactsCard,
    tasksTable,
    ReportsTable,
    ContractsTable,
    DxTabs,
    cCard,
    ActionPointsOverview,
    FileManager,
    EventLogsTable,
    creditNotesTable,
    OrdersTable,
    ExternalInvoicesTable,
    ProjectStats,
    ProjectInfo,
    ProjectCostsTable,
    ProjectCopyPopup,
    DxList,
    MachineryRentalsTable,
    ProjectFiches,
    ProjectCommunicationTable,
    ProjectMeasuringStateAgendaOverview,
    ProjectPurchaseOverview,
    InvoicePaymentTable,
    ProjectProgressionDialog,
    ProjectIsOnHoldPopup,
  },
})
export default class ProjectDetailsPage extends Vue {
  project: any = null;
  navIndex: number = 0;
  sideNavIndex: number = 0;
  sideNavCollapsed: boolean = false;

  loading: boolean = false;
  selectedProjectId: string = '';
  showGenerateQuotationDialog: boolean = false;
  initialise: boolean = true;
  quotations: any[] = [];
  showGenerateProgressStatementDialog: boolean = false;
  showSensitiveInformation: boolean = false;
  securityConfig: ISecurityConfig = SecurityConfig;

  projectProgression: ProjectProgressionDto | null = null;

  pageInfo: any = {
    id: '',
    openTasks: 0,
    openActionPoints: 0,
    estimatedTurnover: 0,
    effectiveTurnover: 0,
    estimatedMaterialCost: 0,
    effectiveMaterialCost: 0,
    estimatedLabourCost: 0,
    effectiveLabourCost: 0,
    effectiveVariaCost: 0,
    estimatedTotalCosts: 0,
    effectiveTotalCosts: 0,
    estimatedProfit: 0,
    effectiveProfit: 0,
    completed: false,
  };

  loggedInEmployee: Employee | null = null;

  private authService = new AuthenticationService();

  sideNavClicked(e: any) {
    if (e.itemData.collapse) {
      this.sideNavCollapsed = !this.sideNavCollapsed;
    } else {
      this.sideNavIndex = e.itemIndex;
    }
  }

  async mounted() {
    await this.loadData();
    this.showSensitiveInformation = this.$auth.canSeeSensitiveInfo();
    this.setNav();
  }

  showProjectProgression() {
    this.projectProgressionDialog.projectId = this.projectId;
    this.projectProgressionDialog.show = true;
    this.projectProgressionDialog.load();
  }

  setNav() {
    setTimeout(() => {
      if (this.$route.query.navIndex) {
        if (!isNaN(this.$route.query.navIndex as any)) {
          this.navIndex = parseInt(this.$route.query.navIndex as any, 11);
        } else {
          this.navIndex = 0;
        }
      } else {
        this.navIndex = 0;
      }

      if (this.$route.query.sideNavIndex) {
        if (!isNaN(this.$route.query.sideNavIndex as any)) {
          this.sideNavIndex = parseInt(this.$route.query.sideNavIndex as any, 10);
        } else {
          this.sideNavIndex = 0;
        }
      }
    }, 300);
  }

  async loadQuotations() {
    this.quotations = (await quotationsRepository.getList(this.projectId)).data;
  }

  async loadPageInfo() {
    try {
      this.pageInfo = (await projectsRepository.getPageInfo(this.projectId)).data;
    } catch (err) {
      // Do nothing
    } finally {
      this.initialise = false;
    }
  }

  async reset() {
    this.initialise = false;
    await this.loadData();
  }

  async loadData() {
    const self = this;
    self.initialise = true;
    this.project = new Project(this.projectId);
    this.loadQuotations();
    this.loadPageInfo();
    this.selectedProjectId = '';
    this.projectProgression = await new PlanningsClient(undefined, this.$axios).getProjectProgression(this.projectId);
    this.loggedInEmployee = await new EmployeesClient(undefined, this.$axios).getLoggedInEmployee();

    setTimeout(() => {
      if (this.project.isOnHold) {
        this.projectIsOnHoldPopup.show();
      }
    }, 200);
  }

  reload() {
    this.project.reload();
  }

  generateQuotation(e: any) {
    (this.$refs.quotationGenerationDialog as quotationGenerationDialog).quoteGenerationModel = Object.assign(
      (this.$refs.quotationGenerationDialog as quotationGenerationDialog).quoteGenerationModel,
      e
    );
    this.showGenerateQuotationDialog = true;
  }

  generateProgressStatement(e: any) {
    (this.$refs.progressStatementGenerationDialog as progressStatementGenerationDialog).progressStatementGenerationModel = Object.assign(
      (this.$refs.progressStatementGenerationDialog as progressStatementGenerationDialog).progressStatementGenerationModel,
      e
    );
    this.showGenerateProgressStatementDialog = true;
  }

  edit() {
    this.selectedProjectId = this.project.id;
    (this.$refs.ProjectUpdateDialog as ProjectUpdateDialog).show(this.project);
  }

  get projectId() {
    return this.$route.params.id;
  }

  get progressStatements() {
    let progressStatements: IProgressStatementListItemDto[] = [];
    if (this.$refs.progressStatementsTable as ProgressStatementsTable) {
      progressStatements = (this.$refs.progressStatementsTable as ProgressStatementsTable).progressStatements;
    }
    return progressStatements;
  }

  get logs() {
    if (this.project.logs !== null) {
      return this.project.logs.slice().reverse();
    }

    return [];
  }

  refreshInvoices() {
    (this.$refs.invoicesTable as InvoicesTable).refresh();
  }

  refreshProgressStatements() {
    (this.$refs.progressStatementsTable as ProgressStatementsTable).refresh();
  }

  async findLocation() {
    if (confirm('Bent u zeker dat u de locatie wilt bepalen?')) {
      const self = this;
      if (navigator.geolocation) {
        self.project.location = {};
        navigator.geolocation.getCurrentPosition(async (position: any) => {
          if (!self.project.location) {
            self.project.location = {};
          }

          if (!self.project.location.accuracy || self.project.location.accuracy < position.coords.accuracy) {
            self.project.location.latitude = position.coords.latitude;
            self.project.location.longitude = position.coords.longitude;
            self.project.location.accuracy = position.coords.accuracy;
          }

          // Save
          self.project.loading = true;
          await projectsRepository.updateLocation({
            id: self.project.id,
            location: self.project.location,
          });
          setTimeout(() => {
            self.project.loading = false;
          }, 150);
        });
      }
    }
  }

  async duplicate() {
    (this.$refs.ProjectCopyPopup as ProjectCopyPopup).show();
  }

  async save() {
    try {
      await projectsRepository.update(this.project);
      notificationService.saved();
    } catch {
      notificationService.failedToSave();
    }
  }

  async saveFromStats(value: any) {
    this.project.statsCompleted = value;
    try {
      await projectsRepository.update(this.project);
      notificationService.saved();
    } catch {
      notificationService.failedToSave();
    }
  }

  get navbarItems() {
    const self = this;
    var items = [
      { icon: 'fas fa-info-circle', text: 'Info', visible: true },
      {
        icon: 'fas fa-euro-sign',
        text: 'Aan- & Verkoop',
        allowedRole: SecurityConfig.administratorGroup,
      },
      {
        icon: 'fas fa-tasks',
        text: `Taken (${self.pageInfo.openTasks})`,
        class: self.pageInfo.openTasks && self.pageInfo.openTasks > 0 ? 'text-danger' : '',
      },
      {
        icon: 'fas fa-clipboard-check',
        text: `Actiepunten (${self.pageInfo.openActionPoints})`,
        class: self.pageInfo.openActionPoints && self.pageInfo.openActionPoints > 0 ? 'text-danger' : '',
      },
      {
        icon: 'far fa-folder',
        text: 'Bestanden',
        allowedRoles: [SecurityConfig.administratorGroup, SecurityConfig.qualityGuardOneSkinGroup],
      },
      {
        icon: 'fas fa-history',
        text: 'Logs',
        allowedRole: SecurityConfig.administratorGroup,
      },
    ];

    (items as any[]).forEach((item) => {
      if (item.allowedRole != undefined && !this.$auth.hasRole(item.allowedRole)) {
        item.visible = false;
      }
    });

    return items;
  }

  get historyConfig(): IEventLogQuery {
    return {
      projectId: this.projectId,
    };
  }

  get hasSidenav() {
    return this.navIndex === 1 || this.navIndex === 0;
  }

  get quotationContacts() {
    const clients = this.project.contacts.filter(
      (contact: AssignedContact) => contact.sendQuotation && contact.tags != undefined && contact.tags.length > 0 && contact.tags.some((t: string) => t == 'Klant')
    );

    return clients.map((client: AssignedContact) => client.contact);
  }

  get sideNavigationItems() {
    const self = this;
    if (this.navIndex === 0) {
      var items0 = [
        { text: self.sideNavCollapsed ? '' : 'Info', icon: 'product' },
        { text: self.sideNavCollapsed ? '' : 'Communicatie', icon: 'fas fa-users' },

        {
          text: self.sideNavCollapsed ? '' : 'Contacten',
          icon: 'fas fa-address-book',
          allowedRoles: [SecurityConfig.administratorGroup, SecurityConfig.qualityGuardOneSkinGroup],
        },
        {
          text: self.sideNavCollapsed ? '' : 'Bezoeken & verslagen',
          icon: 'fas fa-clipboard',
        },
        {
          text: self.sideNavCollapsed ? '' : 'Opmetingen',
          icon: 'fas fa-ruler',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Meetstaten',
          icon: 'fas fa-file-alt',
          allowedRoles: [SecurityConfig.administratorGroup, SecurityConfig.qualityGuardOneSkinGroup],
        },
        {
          text: self.sideNavCollapsed ? '' : 'Contracten',
          icon: 'fas fa-file-contract',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Vorderingstaten',
          icon: 'fas fa-ruler-combined',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Verhuur',
          icon: 'fas fa-snowplow',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Calculatie',
          icon: 'fas fa-calculator',
          visible: self.showSensitiveInformation,
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Technische fiches',
          icon: 'fas fa-archive',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: self.sideNavCollapsed ? '' : 'Meetstaat planning',
          icon: 'fas fa-calendar',
          allowedRole: SecurityConfig.administratorGroup,
        },

        {
          text: '',
          icon: 'fas fa-chevron-circle-left',
          collapse: true,
          visible: !self.sideNavCollapsed,
        },
        {
          text: '',
          icon: 'fas fa-chevron-circle-right',
          collapse: true,
          visible: self.sideNavCollapsed,
        },
      ];

      (items0 as any[]).forEach((item) => {
        if (item.allowedRole != undefined && !this.$auth.hasRole(item.allowedRole)) {
          item.visible = false;
        }
      });

      return items0;
    }

    if (this.navIndex === 1) {
      var items1 = [
        {
          icon: 'fas fa-file',
          text: self.sideNavCollapsed ? '' : 'Offertes',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-file-invoice',
          text: self.sideNavCollapsed ? '' : 'Facturen',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-file-excel',
          text: self.sideNavCollapsed ? '' : "Creditnota's",
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-shopping-cart',
          text: self.sideNavCollapsed ? '' : 'Bestellingen',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-file-download',
          text: self.sideNavCollapsed ? '' : 'Aankoop',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-euro-sign',
          text: self.sideNavCollapsed ? '' : 'Kosten',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-chart-line',
          text: self.sideNavCollapsed ? '' : 'Overzicht',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          icon: 'fas fa-money-bill',
          text: self.sideNavCollapsed ? '' : 'Betalingen',
          allowedRole: SecurityConfig.administratorGroup,
        },
        {
          text: '',
          icon: 'fas fa-chevron-circle-left',
          collapse: true,
          visible: !self.sideNavCollapsed,
        },
        {
          text: '',
          icon: 'fas fa-chevron-circle-right',
          collapse: true,
          visible: self.sideNavCollapsed,
        },
      ];

      (items1 as any[]).forEach((item) => {
        if (item.allowedRole != undefined && !this.$auth.hasRole(item.allowedRole)) {
          item.visible = false;
        }
      });

      return items1;
    }

    return [];
  }

  get projectProgressionDialog() {
    return this.$refs?.projectProgressionDialog as ProjectProgressionDialog;
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  get currentUserCanToggleProjectOnHold(): boolean {
    return this.loggedInEmployee?.canToggleProjectsOnHold ?? false;
  }

  isNotInRole(roles: string[]): boolean {
    return this.authService.isNotInRole(roles)
  }

  @Watch('projectId')
  async onProjectChange() {
    await this.loadData();
  }

  @Watch('navIndex')
  onNavIndexChanged(value: number, oldValue: number) {
    if (value === -1 && oldValue !== -1) {
      value = oldValue;
    }

    // alert(value);
    // alert(oldValue)
    if (value !== -1 && !this.initialise && value !== oldValue) {
      this.$router.replace({
        query: { navIndex: '' + value, sideNavIndex: '' + this.sideNavIndex },
      });
    } else {
      this.setNav();
    }
  }

  @Watch('sideNavIndex')
  onSideNavIndexChanged(value: number, oldValue: number) {
    if (value !== -1 && !this.initialise) {
      this.$router.replace({
        query: { sideNavIndex: '' + value, navIndex: '' + this.navIndex },
      });
    }
  }
}
